const dayjs = require('dayjs')
const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')

dayjs.extend(utc)
dayjs.extend(timezone)

const utcToWat = (utcTime) => {
  return dayjs(utcTime).tz('Africa/Lagos').format('YYYY-MM-DD HH:mm:ss.SSS')
}

export default utcToWat
